export const Login_Request="Login_Request"
export const Login_Success="Login_Success"
export const Login_Failure="Login_Failure"
export const Signup_Success="Signup_Success"
export const Logout_Success="Logout_Success"

//clear error
export const Clear_Error="Clear_Error"